import BpmnModeler from 'bpmn-js/lib/Modeler';
import BpmnViewer from 'bpmn-js/lib/Viewer';
import axios from "axios/index";

const Bpmn = {
    bpmnViewer: null,
    bpmnModeler: null,
    bpmnConfig: null,
    element: null,
    modelingConfig: {
        editingStack: []
    },
    saveDiagram: function (callback) {

        this.bpmnModeler.saveXML({format: true}, function (err, xml) {

            if (err) {
                return console.error('could not save BPMN 2.0 diagram', err);
            }
            console.log(xml);
            xml = Bpmn.decodeHTML(xml);
            callback(xml);
        });
    },

    startWorkflow: function () {
        $.ajax({
            url: "<c:url value='/rest/v1/workflow/start?processId='/>" + document.getElementById("createForm.processDefinitionId").value,
            type: "POST",
            contentType: "application/json"
        }).done(function (response) {
            alert("Save success");
            goBack();
        }).fail(function (jqXHR, textStatus) {
            alert("Save false: " + jqXHR.responseText);
        });
    },

    exportDiagram: function () {
        this.bpmnModeler.saveXML({format: true}, function (err, xml) {

            if (err) {
                return console.error('could not save BPMN 2.0 diagram', err);
            }
            document.getElementById("createForm.flowConfig").value = xml;
            console.log(xml);
        });
    },

    decodeHTML: function (html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        console.log(txt.value);
        return txt.value;
    },

    loadConfig: function (config) {
        this.bpmnConfig = config;
        console.log(this.bpmnConfig);
    },

    getAllProperties: function (name) {
        var properties = [];
        let bpmnConfig = this.bpmnConfig;
        for (var i = 0; i < bpmnConfig.types.length; i++) {
            if (name == bpmnConfig.types[i].name) {
                //
                // get all properties of parent
                //
                console.log(bpmnConfig.types[i].superClass);
                if (bpmnConfig.types[i].superClass != undefined && bpmnConfig.types[i].superClass != null) {
                    for (var j = 0; j < bpmnConfig.types[i].superClass.length; j++) {
                        var parentProperties = this.getAllProperties(bpmnConfig.types[i].superClass[j]);
                        //console.log(parentProperties);
                        if (parentProperties.length > 0) {
                            properties = properties.concat(parentProperties);
                        }
                    }
                }
                //
                // get properties of item
                //
                if (bpmnConfig.types[i].properties != undefined && bpmnConfig.types[i].properties != null) {
                    properties = properties.concat(bpmnConfig.types[i].properties);
                }
                break;
            }
        }

        for (var i = properties.length - 1; i > 0; i--) {
            for (var j = i - 1; j >= 0; j--) {
                if (properties[i].name == properties[j].name && properties[i].type == properties[j].type) {
                    properties.splice(i, 1);
                    break;
                }
            }
        }
        return properties;
    },

    //
    // update property value of one flow element
    //
    updateProperty: function () {
        let name = this.getAttribute("name");
        let elementId = this.dataset.elementid;
        let attributeType = this.getAttribute("attributeType");
        let isExtent = this.dataset.isextent;
        let uri = this.dataset.namespace;
        Bpmn.updatePropertyByName(name, elementId, attributeType, uri, isExtent, this.value);
    },

    updatePropertyByName: function (name, elementId, attributeType, uri, isExtent, value) {
        console.log(name + "-" + elementId + "-" + attributeType + "-" + uri + "-" + isExtent)
        let bpmnModeler = Bpmn.bpmnModeler;
        let elementRegistry = bpmnModeler.get('elementRegistry');
        let element = elementRegistry.get(elementId);
        let modeling = bpmnModeler.get('modeling');
        let ob;
        if (name.indexOf(":") >= 0) {
            let definitions = bpmnModeler._definitions;
            let namespace = name.split(":")[0];
            console.log(namespace);
            definitions.set('xmlns:' + namespace, uri);
            console.log(definitions);
        } else if (attributeType.indexOf(":") >= 0) {
            let definitions = bpmnModeler._definitions;
            let namespace = attributeType.split(":")[0];
            console.log(namespace);
            definitions.set('xmlns:' + namespace, uri);
        }
        console.log(bpmnModeler);

        if (isExtent == "true") {
            let namespace = attributeType.split(":")[0];
            let moddle = bpmnModeler.get("moddle");
            let stringValue = moddle.createAny("activiti:expression", namespace, {
                $body: value
            });
            let properties = moddle.createAny(attributeType, namespace, {
                name: name,
                $children: [stringValue]
            });
            console.log(element);
            let extensionElement = element.businessObject["extensionElements"];
            if (extensionElement == undefined || extensionElement == null) {
                extensionElement = moddle.create("bpmn:ExtensionElements");
                //element.businessObject["extensionElements"] = extensionElement;
            }
            console.log(extensionElement);
            let bHas = false;
            for (var i = 0; i < extensionElement.get("values").length; i++) {
                if (extensionElement.get("values")[i]["name"] == name) {
                    extensionElement.get("values")[i] = properties;
                    bHas = true;
                    break;
                }
            }
            if (!bHas) {
                extensionElement.get("values").push(properties);
            }
            ob = {
                "extensionElements": extensionElement
            };
            modeling.updateProperties(element, ob);
        } else {
            ob = {};
            ob[name] = value;

            modeling.updateProperties(element, ob);
        }
    },

    updatePropertyOfModel: function () {
        let modelingConfig = Bpmn.modelingConfig;
        console.log(modelingConfig);
        let currentEditingItem = modelingConfig.editingStack[modelingConfig.editingStack.length - 1];

        let name = this.getAttribute("name");
        let ob = {};
        ob[name] = this.value;
        //console.log(ob);
        currentEditingItem.value[name] = this.value;
        console.log(this.value);
        //var modeling = bpmnModeler.get('modeling');
        //modeling.updateProperties(currentEditingItem, ob);
    },

    showDataDialog: function () {
        let name = this.getAttribute("name");
        let type = this.getAttribute("attributeType");
        let isExtent = this.dataset.isextent;
        let uri = this.dataset.namespace;
        let isMany = this.getAttribute("ismany");
        let multiSelect = this.getAttribute("multiSelect");
        let valuefield = this.getAttribute("valuefield");
        let value = this.value;
        let sql = this.getAttribute("sql");
        console.log("isMany:" + isMany);
        let elementId = this.dataset.elementid;
        console.log(name + ":" + type + ":" + elementId);
        let bpmnModeler = Bpmn.bpmnModeler;
        let elementRegistry = bpmnModeler.get('elementRegistry');
        let element = elementRegistry.get(elementId);
        Bpmn.modelingConfig.editingStack.push({
            'property': name,
            'value': element,
            "attributeType": type,
            "uri": uri,
            "isExtent": isExtent
        });
        Bpmn.element.loadData(sql, valuefield, value, multiSelect);
    },

    showEditChildProperty: function (object, propertyPanelId, childLevel) {
        let bpmnModeler = Bpmn.bpmnModeler;
        let name = object.getAttribute("name");
        let type = object.getAttribute("attributeType");
        let isMany = object.getAttribute("ismany");
        console.log("isMany:" + isMany);


        /*
                var elementId = object.dataset.elementid;
                console.log(name + ":" + type + ":" + elementId);
                var elementRegistry = bpmnModeler.get('elementRegistry');
                var element = elementRegistry.get(elementId);
                console.log(element);
                var childElement = null;
                if(element != undefined && element != null ){
                    console.log(element.businessObject);
                    childElement = element.businessObject[name];
                }
                console.log(childElement);
        */

        let element = Bpmn.modelingConfig.editingStack[Bpmn.modelingConfig.editingStack.length - 1].value;
        if (Array.isArray(element)) {
            element = element[0];
        }
        let childElement = element[name];

        let moodle = bpmnModeler.get("moddle");
        if (isMany == "true") {
            console.log("array");
            if (childElement == undefined || childElement == null || childElement.length == 0) {
                childElement = [moodle.create('bpmn:' + type, {})];
            }
        } else {
            console.log("item");
            if (childElement == undefined || childElement == null) {
                console.log("create item");
                childElement = moodle.create('bpmn:' + type, {});
            }
        }
        Bpmn.loadChildProperties(childElement, propertyPanelId, name, type, isMany);
        if (childLevel == 1) {
            Bpmn.element.propertyDialog = true;
        } else if (childLevel == 2) {
            Bpmn.element.childPropertyDialog = true;
        }
    },

    showEditMoodleProperty: function () {
        Bpmn.showEditChildProperty(this, "propertiesForm", 1);
    },

    showEditChildMoodleProperty: function () {
        Bpmn.showEditChildProperty(this, "childPropertiesForm", 2);

    },

    loadProperties: function (objectEl, panelId, propertyName) {
        console.log(objectEl);
        this.modelingConfig.editingStack.push({'property': propertyName, 'value': objectEl});
        let type = null;
        if (Array.isArray(objectEl)) {
            type = objectEl[0].$type;
        } else {
            type = objectEl.$type;
        }
        console.log("type:" + type);
        type = type.split(":")[1];
        console.log(type);
        let properties = this.getAllProperties(type);
        //
        // clear all control in panel
        //
        var panel = document.getElementById(panelId);
        panel.innerHTML = "";
        var row;

        let bpmnModeler = Bpmn.bpmnModeler;
        let elementRegistry = bpmnModeler.get('elementRegistry');
        let modeling = bpmnModeler.get('modeling');

        for (var i = 0; i < properties.length; i++) {
            row = document.createElement("div");
            row.setAttribute("class", "row");
            panel.appendChild(row);

            var label = document.createElement("div");
            label.setAttribute("class", "label col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4");
            if (properties[i].label != undefined && properties[i].label != null) {
                label.innerText = properties[i].label;
            } else {
                label.innerText = properties[i].name;
            }
            row.appendChild(label);
            var inpDiv = document.createElement("div");
            inpDiv.setAttribute("class", "inputDiv col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8");
            var ctrl;
            if (properties[i].type == "String" || properties[i].type == "Integer") {
                ctrl = document.createElement("input");
                if (properties[i].type == "Integer") {
                    ctrl.setAttribute("type", "number");
                }
                console.log("property name: " + properties[i].name);
                var propertyValue;
                if (properties[i].name.indexOf(":") >= 0) {
                    console.log("property attrs: " + objectEl.get("attrs"));
                    console.log("property value: " + objectEl.$attrs[properties[i].name]);
                    propertyValue = objectEl.$attrs[properties[i].name];
                } else {
                    console.log("property value: " + objectEl[properties[i].name]);
                    propertyValue = objectEl[properties[i].name];
                }

                console.log(properties[i].name);
                console.log(objectEl);

                if (propertyValue != undefined && propertyValue != null) {
                    if (properties[i].name == "script") {
                        if (propertyValue.indexOf("<![CDATA[") < 0) {
                            ctrl.value = "<![CDATA[" + propertyValue + "]]>";
                            let ob = {"script": "<![CDATA[" + propertyValue + "]]>"};
                            let element = elementRegistry.get(objectEl.id);
                            modeling.updateProperties(element, ob);
                        } else {
                            ctrl.value = propertyValue;
                        }

                    } else {
                        ctrl.value = propertyValue;
                    }
                }
                ctrl.onchange = this.updateProperty;
            } else if (properties[i].type == "Boolean") {
                ctrl = document.createElement("select");
                var tO = document.createElement("option");
                tO.setAttribute("value", "true");
                tO.innerHTML = "True";
                ctrl.appendChild(tO);
                var fO = document.createElement("option");
                fO.setAttribute("value", "false");
                fO.innerHTML = "False";
                ctrl.appendChild(fO);
                if (objectEl[properties[i].name] != undefined) {
                    console.log(objectEl[properties[i].name]);
                    ctrl.value = objectEl[properties[i].name];
                }
                ctrl.onchange = this.updateProperty;
            } else if (properties[i].type == "activiti:field") {
                ctrl = document.createElement("input");
                ctrl.onchange = this.updateProperty;
                if (objectEl.extensionElements != undefined && objectEl.extensionElements != null) {
                    for (var j = 0; j < objectEl.extensionElements.get("values").length; j++) {
                        if (objectEl.extensionElements.get("values")[j]["name"] == properties[i].name) {
                            console.log(objectEl.extensionElements.get("values")[j]);
                            ctrl.value = objectEl.extensionElements.get("values")[j]["$children"][0]["$body"];
                            break;
                        }
                    }
                }
                //ctrl.value = objectEl.extensionElements[properties[i].name];
            } else if (properties[i].type == "custom:field") {
                ctrl = document.createElement("input");
                ctrl.onchange = this.updateProperty;
                if (objectEl.extensionElements != undefined && objectEl.extensionElements != null) {
                    console.log("---extension element---");
                    console.log(objectEl.extensionElements.get("values"));
                    for (var j = 0; j < objectEl.extensionElements.get("values").length; j++) {
                        if (objectEl.extensionElements.get("values")[j]["name"] == properties[i].name) {
                            console.log(objectEl.extensionElements.get("values")[j]);
                            ctrl.value = objectEl.extensionElements.get("values")[j]["$children"][0]["$body"];
                            break;
                        }
                    }
                }
            } else {
                ctrl = document.createElement("input");
                ctrl.setAttribute("type", "button");
                ctrl.setAttribute("value", "edit");
                ctrl.setAttribute("isMany", properties[i].isMany);
                ctrl.onclick = this.showEditMoodleProperty;
            }
            if (properties[i].source != undefined) {
                //ctrl.setAttribute("readonly", true);
                ctrl.setAttribute("valueField", properties[i].valueField);
                ctrl.setAttribute("isMany", properties[i].isMany);
                ctrl.setAttribute("multiSelect", properties[i].multiSelect);
                ctrl.setAttribute("sql", properties[i].source);
                ctrl.onclick = this.showDataDialog;
            }

            ctrl.setAttribute("name", properties[i].name);
            ctrl.setAttribute("attributeType", properties[i].type);
            ctrl.setAttribute("data-isExtent", properties[i].isExtent);
            ctrl.setAttribute("data-namespace", properties[i].namespace);
            ctrl.setAttribute("data-elementId", objectEl.id);
            inpDiv.appendChild(ctrl);
            row.appendChild(inpDiv);
        }
    },

    clearProperties: function () {
        var propertiesPanel = document.getElementById("js-properties-panel");
        propertiesPanel.innerHTML = "";
    },

    loadChildProperties: function (objectEl, panelId, propertyName, type, isMany) {
        var type = null;
        var workingOb;
        if (Array.isArray(objectEl)) {
            type = objectEl[0].$type;
            workingOb = objectEl[0];
        } else {
            type = objectEl.$type;
            workingOb = objectEl;
        }
        console.log("type:" + type);
        type = type.split(":")[1];
        console.log(type);
        var properties = this.getAllProperties(type);
        //
        // init table
        //
        if (isMany == true) {
            document.getElementById("tableDiv").style.display = "none";
            var table = document.getElementById("propertiesTable");
            table.setAttribute("isMany", true);
            //
            // init header of table
            //
            table.innerHTML = "";
            var tr = document.createElement("tr");
            table.appendChild(tr);
            for (var i = 0; i < properties.length; i++) {
                if (properties[i].type == "String" || properties[i].type == "Integer" || properties[i].type == "Boolean") {
                    var th = document.createElement("th");
                    th.innerHTML = properties[i].name;
                    tr.appendChild(th);
                }
            }
            //
            // init data
            //

        } else {
            document.getElementById("tableDiv").style.display = "none";
            var table = document.getElementById("propertiesTable");
            table.setAttribute("isMany", false);
        }
        console.log(objectEl);
        this.modelingConfig.editingStack.push({'property': propertyName, 'value': objectEl});
        //
        // clear all control in panel
        //
        var panel = document.getElementById(panelId);
        panel.innerHTML = "";
        var row;
        for (var i = 0; i < properties.length; i++) {
            console.log(properties[i].type);
            row = document.createElement("div");
            row.setAttribute("class", "row");

            var label = document.createElement("div");
            label.setAttribute("class", "label col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4");
            label.innerHTML = properties[i].name;
            row.appendChild(label);
            var inpDiv = document.createElement("div");
            inpDiv.setAttribute("class", "inputDiv col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8");
            var ctrl;
            if (properties[i].type == "String" || properties[i].type == "Integer") {
                ctrl = document.createElement("input");
                if (properties[i].type == "Integer") {
                    ctrl.setAttribute("type", "number");
                }
                if (workingOb[properties[i].name] != undefined) {
                    console.log(workingOb[properties[i].name]);
                    ctrl.value = workingOb[properties[i].name];
                }
                ctrl.onchange = this.updatePropertyOfModel;
            } else if (properties[i].type == "Boolean") {
                ctrl = document.createElement("select");
                var tO = document.createElement("option");
                tO.setAttribute("value", "true");
                tO.innerHTML = "True";
                ctrl.appendChild(tO);
                var fO = document.createElement("option");
                fO.setAttribute("value", "false");
                fO.innerHTML = "False";
                ctrl.appendChild(fO);
                if (workingOb[properties[i].name] != undefined) {
                    console.log(workingOb[properties[i].name]);
                    ctrl.value = workingOb[properties[i].name];
                }
                ctrl.onchange = this.updatePropertyOfModel;
            } else {
                //
                // Compound property
                //
                ctrl = document.createElement("input");
                ctrl.setAttribute("type", "button");
                ctrl.onclick = this.showEditChildMoodleProperty;
            }
            ctrl.setAttribute("name", properties[i].name);
            ctrl.setAttribute("attributeType", properties[i].type);
            ctrl.setAttribute("data-elementId", workingOb.id);
            inpDiv.appendChild(ctrl);
            row.appendChild(inpDiv);
            panel.appendChild(row);
        }
    },

    openDiagram: function (bpmnXML) {

        // import diagram

        bpmnXML = this.decodeHTML(bpmnXML);
        console.log(bpmnXML);
        console.log("--- open diagram ---");
        this.bpmnModeler.importXML(bpmnXML, function (err) {

            if (err) {
                Bpmn.initDiagram(null);
                return console.error('could not import BPMN 2.0 diagram', err);
            }

            var elementRegistry = Bpmn.bpmnModeler.get('elementRegistry');
            var process = elementRegistry.get("Process_1");
            if (process != null) {
                let modeling = Bpmn.bpmnModeler.get('modeling');
                let ob = {id: "Process_" + (new Date()).getTime()}
                modeling.updateProperties(process, ob);
            }


            // access modeler components
            var canvas = Bpmn.bpmnModeler.get('canvas');

            // zoom to fit full viewport
            canvas.zoom('fit-viewport');

            // attach an overlay to a node

            var eventBus = Bpmn.bpmnModeler.get('eventBus');
            // you may hook into any of the following events
            /*
                        var events = [
                            'element.hover',
                            'element.out',
                            'element.click',
                            'element.dblclick',
                            'element.mousedown',
                            'element.mouseup'
                        ];
            */

            var events = [
                'element.click'
            ];
            events.forEach(function (event) {

                eventBus.on(event, function (e) {
                    Bpmn.modelingConfig.editingStack.length = 0;
                    eventBus.fire('element.changed', {element: [e.element]});
                    Bpmn.loadProperties(e.element.businessObject, "js-properties-panel", "");
                });
            });
        });
        //
        // remove bpmn tag
        //
        var canvasItem = document.getElementById("canvas");
        var arrA = canvasItem.getElementsByTagName("a");
        if (arrA.length > 0) {
            for (var i = 0; i < arrA.length; i++) {
                arrA[i].parentNode.removeChild(arrA[i]);
                //canvasItem.removeChild(arrA[i]);
            }
        }
    },

    initBPMNM: function () {
        this.bpmnModeler = new BpmnModeler({
            container: '#canvas',
            propertiesPanel: {
                parent: '#js-properties-panel'
            },
            keyboard: {
                bindTo: window
            }
        });
        let bpmnJsonUrl = "plugin/bpmn/bpmn-js/bpmn.json";
        axios.get(bpmnJsonUrl).then((data) => {
            console.log("---bpmn.json---");
        console.log(data);
        this.loadConfig(data);
    })
        ;
    },

    initViewer: function (id) {
        console.log(id);
        Bpmn.bpmnViewer = new BpmnViewer(
            {
                container: id
            });
        console.log(Bpmn.bpmnViewer);
    },

    loadViewer: function (bpmnXML, currentTask) {
        Bpmn.bpmnViewer.importXML(bpmnXML, function (err) {

            if (err) {
                return console.error('could not import BPMN 2.0 diagram', err);
            }

            let overlays = Bpmn.bpmnViewer.get('overlays');
            let canvas = Bpmn.bpmnViewer.get('canvas');
            let elementRegistry = Bpmn.bpmnViewer.get('elementRegistry');
            canvas.zoom('fit-viewport');

            let shape = elementRegistry.get(currentTask);

            let $overlayHtml = $('<div class="highlight-overlay">')
                .css({
                    width: shape.width,
                    height: shape.height,
                    backgroundColor: 'rgba(255,152,0,0.5)',
                    borderRadius: '10px'
                });
            overlays.add(currentTask, {
                position: {
                    top: 0,
                    left: 0
                },
                html: $overlayHtml
            });
        });
        let canvasItem = document.getElementById("canvas");
        let arrA = canvasItem.getElementsByTagName("a");
        if (arrA.length > 0) {
            for (let i = 0; i < arrA.length; i++) {
                arrA[i].parentNode.removeChild(arrA[i]);
            }
        }
    },

    updateProcessingTask: function (task) {
        let overlays = Bpmn.bpmnViewer.get('overlays');
        let canvas = Bpmn.bpmnViewer.get('canvas');
        let elementRegistry = Bpmn.bpmnViewer.get('elementRegistry');
        let shape = elementRegistry.get(task);

        let $overlayHtml = $('<div class="highlight-overlay">')
            .css({
                width: shape.width,
                height: shape.height,
                backgroundColor: 'rgba(255,152,0,0.5)',
                borderRadius: '10px'
            });
        overlays.add(task, {
            position: {
                top: 0,
                left: 0
            },
            html: $overlayHtml
        });

    },

    initDiagram: function (xml) {
        //
        // init config
        //
        this.clearProperties();
        if (xml == null || xml == undefined) {
            //
            // load model
            //
            console.log("---here ----");
            let diagramUrl = "plugin/bpmn/empty.bpmn";
            axios.get(diagramUrl).then((data) => {
                console.log("---example.bpmn---");
            this.openDiagram(data);
        })
            ;
        } else {
            console.log("---here xml ----");
            this.openDiagram(xml);
        }
    },

    onCloseDialog: function () {
        Bpmn.element.propertyDialog = false;
    },

    onSaveProperties: function () {
        let modelingConfig = Bpmn.modelingConfig;
        let currentEditingItem = modelingConfig.editingStack[modelingConfig.editingStack.length - 1];
        let item = currentEditingItem.value;
        let property = currentEditingItem.property;
        let updateItem = modelingConfig.editingStack[modelingConfig.editingStack.length - 2].value;
        let elementRegistry = Bpmn.bpmnModeler.get('elementRegistry');
        let element = elementRegistry.get(updateItem.id);
        console.log(updateItem.id);
        console.log(element);
        let modeling = Bpmn.bpmnModeler.get('modeling');
        let ob = {};
        let table = document.getElementById("propertiesTable");
        let isMany = table.getAttribute("isMany");
        console.log(isMany);
        if (isMany == "true") {
            ob[property] = [item];
        } else {
            ob[property] = item;
        }
        console.log(ob);
        console.log(element);
        modeling.updateProperties(element, ob);
        console.log("after update");

        Bpmn.element.propertyDialog = false;
    },

    onSaveChildProperties: function () {
        let modelingConfig = Bpmn.modelingConfig;
        let currentEditingItem = modelingConfig.editingStack[modelingConfig.editingStack.length - 1];
        let item = currentEditingItem.value;
        let property = currentEditingItem.property;
        let updateItem = modelingConfig.editingStack[modelingConfig.editingStack.length - 2].value;
        if (Array.isArray(updateItem)) {
            updateItem = updateItem[0];
        }
        console.log(updateItem);
        //let elementRegistry = Bpmn.bpmnModeler.get('elementRegistry');
        let modeling = Bpmn.bpmnModeler.get('modeling');
        let ob = {};
        let isMany = "false";
        //let table = document.getElementById("propertiesTable");
        //let isMany = table.getAttribute("isMany");
        //console.log(isMany);
        console.log("after update");
        //modeling.updateProperties(updateItem, ob);
        updateItem[property] = item;
        console.log(updateItem);

        Bpmn.element.childPropertyDialog = false;

    },

    updatePropertyFromDlg: function (value) {
        let currentEditingItem = Bpmn.modelingConfig.editingStack[Bpmn.modelingConfig.editingStack.length - 1];
        let item = currentEditingItem.value;
        let type = currentEditingItem.attributeType;
        let propertyName = currentEditingItem.property;
        let isExtent = currentEditingItem.isExtent;
        let uri = currentEditingItem.uri;
        Bpmn.updatePropertyByName(propertyName, item.id, type, uri, isExtent, value);
        Bpmn.loadProperties(item.businessObject, "js-properties-panel", "");
    }
}

export default Bpmn;